import React from "react";
import cn from "classnames";
import styles from "./Program.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";

const steps = [
  {
    number: "1",
    title: "Accès & complétion",
    description: "Saisie simplifiée des informations par toutes les parties prenantes, via leur espace personnel sécurisé et intuitif.",
    color: "#39B7CD", // blue
  },
  {
    number: "2",
    title: "Signature du dossier",
    description: "Validation et signature électronique des documents, garantissant conformité et gain de temps.",
    color: "#FDCB6E", // yellow
  },
  {
    number: "3",
    title: "Diffusion aux OPCO",
    description: "Envoi automatique et sécurisé des pièces aux OPCO, dès la validation du dossier.",
    color: "#39CD54", // green
  },
  {
    number: "4",
    title: "Suivi des échéanciers",
    description: "Historique complet et détaillé des échéanciers de paiement et des versements effectués.",
    color: "#CABDFF", // purple
  },
];

const FonctionnalitesContrat = () => {
  return (
    <div className={cn("section-bg", styles.book)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.wrap}>
          {/* Left side - Steps */}
          <div className={styles.stepsContainer}>
            <div className={styles.stepsList}>
              {steps.map((step, index) => (
                <ScrollParallax key={index} className={styles.stepItem}>
                  <div className={styles.stepNumber} style={{ backgroundColor: step.color }}>
                    {step.number}
                  </div>
                  <div className={styles.stepContent}>
                    <h3 className={styles.stepTitle}>{step.title}</h3>
                    <p className={styles.stepDescription}>{step.description}</p>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>

          {/* Right side - Visual elements */}
          <div className={styles.visualContainer}>
            <div className={styles.header}>
              <h2 className={styles.title}>
                Un suivi <span className={styles.highlight}>étape</span>
                <br />
                par <span className={styles.highlight}>étape.</span>
              </h2>
            </div>
            <div className={styles.decorativeCenter}>
              <img src="/images/content/SignIllus.svg" alt="Decorative illustration" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FonctionnalitesContrat;
